// Russian language pack

export default {
  // --- Cards ---
  'card.damage.label': 'Точный удар',
  'card.damage.desc': '+{value} к урону',
  'card.maxHp.label': 'Крепкий череп',
  'card.maxHp.desc': '+{value} макс. HP и исцеление',
  'card.speed.label': 'Лёгкая походка',
  'card.speed.desc': '+{speed} к скорости, −{cd}% к перезарядке атаки',
  'card.attackRange.label': 'Длинная рука',
  'card.attackRange.desc': '+{value} к радиусу атаки',
  'card.cooldown.label': 'Быстрый замах',
  'card.cooldown.desc': '−{value}% к перезарядке атаки',
  'card.lifesteal.label': 'Вампиризм',
  'card.lifesteal.desc': '+{value}% HP от нанесённого урона',
  'card.magnet.label': 'Жадные руки',
  'card.magnet.desc': '+{value}% к радиусу магнита',
  'card.thorns.label': 'Шипы',
  'card.thorns.desc': 'Враги в ближнем бою получают {value}% урона в ответ',
  'card.regen.label': 'Второе дыхание',
  'card.regen.desc': '+{value} HP/сек регенерации',
  'card.dashCooldown.label': 'Быстрые ноги',
  'card.dashCooldown.desc': '−{cd}% к кулдауну рывка, +{iframe}с к окну неуязвимости',
  'card.draftSize.label': 'Жизнь по плану',
  'card.draftSize.desc': '+1 карта в выборе магазина (макс. 5)',
  'card.fortify.label': 'Жажда крови',
  'card.fortify.desc': '+{value} HP за каждое убийство стража',
  'card.armorBreak.label': 'Сын кузнеца',
  'card.armorBreak.desc': 'Атаки игнорируют броню',
  'card.cleave.label': 'Дровосек',
  'card.cleave.desc': '+{value}% урона по соседним врагам в зоне атаки',
  'card.doubleStrike.label': 'Двойной удар',
  'card.doubleStrike.desc': 'Каждый {n}-й удар — кулдаун ×0.5',
  'card.doubleStrike.descFull': 'Все ритм-триггеры активны',
  'card.crit.label': 'В рубашке родился',
  'card.crit.desc': '{value}% шанс нанести удвоенный урон',
  'card.phantom.label': 'Дитя ветра',
  'card.phantom.desc': 'Неуязвимость после рывка — до 60% его перезарядки',
  'card.glassCannon.label': 'Берсерк',
  'card.glassCannon.desc': '+{dmg} урона, −{hp} макс. HP',
  'card.wideArc.label': 'Круговой удар',
  'card.wideArc.desc': 'Атака бьёт во все стороны',
  'card.rebirth.label': 'Перерождение',
  'card.rebirth.desc': 'Умирай, рождайся заново. Сброс к волне 1; счёт сохраняется, охрана становится быстрее.',
  'cutscene.rebirth.title': 'ПЕРЕРОЖДЕНИЕ',
  'cutscene.rebirth.aphorism': 'Умирай, рождайся заново',
  'cutscene.rebirth.tail': 'волна {wave} → 1',
  'cutscene.rebirth.subtitle': 'волна {wave} → 1',

  // --- Caravan types ---
  'caravan.donkey': 'Осёл',
  'caravan.wagon': 'Телега',
  'caravan.royal': 'Карета',

  // --- Main menu ---
  'menu.title': 'КОРОВАНЫ',
  'menu.subtitle': 'грабь корованы!',
  'menu.record': 'Рекорд: {score}  •  Волна: {wave}',
  'menu.controls1': 'WASD / стрелки - движение',
  'menu.controls2': 'Пробел / ПКМ - атака   •   ЛКМ - движение   •   Shift - рывок   •   Q - супер-удар   •   E - магазин',
  'menu.controls3': 'Esc - пауза   •   M - звук   •   F - полный экран   •   Caps Lock - автоатака',
  'menu.start': '[ Enter / клик — начать ]',
  'menu.touchControls1': 'Коснись и веди - движение',
  'menu.touchControls2': '⚔ - атака (потяни влево на замок - автоатака)   •   ⚡ - рывок   •   💥 - супер-удар',
  'menu.touchStart': '[ коснись, чтобы начать ]',
  'menu.updateAvailable': '↻ Доступна новая версия ({short}) — нажми чтобы перезагрузить',

  // --- HUD ---
  'hud.wave': 'Волна: {wave}',
  'hud.waveBoss': 'Волна: {wave} [БОСС]',
  'hud.score': 'Счёт: {score}',
  'hud.caravansGuards': 'Корованы: {caravans}  Охрана: {guards}',

  // --- Shop ---
  'shop.titleShop': 'ТОРГОВЕЦ',
  'shop.titleInterwave': 'ВЫБЕРИ КАРТУ',
  'shop.gold': 'Золото: {gold}',
  'shop.soldOut': 'РАСПРОДАНО',
  'shop.soldOutHint': 'Приходи на следующей волне',
  'shop.exit': 'Выйти из шопа',
  'shop.skip': 'Пропустить >',
  'shop.reroll': '⟳ Реролл ({cost})',
  'shop.stats': 'Характеристики:',
  'shop.statDamage': 'Урон: {value}',
  'shop.statHp': 'HP: {hp}/{maxHp}',
  'shop.statSpeed': 'Скорость: {value}',
  'shop.statRange': 'Радиус: {value}',
  'shop.statAtkSpeed': 'Темп атаки: {value}/с',
  'shop.statVamp': 'Вамп: {value}%',
  'shop.statThorns': 'Шипы: {value}%',
  'shop.statMagnet': 'Магнит: x{value}',
  'shop.statWideArc': 'Круговая атака',
  'shop.interact': '[E] ТОРГОВАТЬ',
  'shop.interactTouch': 'ТАПНИ, ЧТОБЫ ТОРГОВАТЬ',

  // --- Wave end summary ---
  'waveEnd.title': 'ВОЛНА {wave} ОЧИЩЕНА',
  'waveEnd.caravans': 'Корованов ограблено: {robbed} / {total}',
  'waveEnd.guards': 'Охранников убито: {count}',
  'waveEnd.damage': 'Получено урона: {value}',
  'waveEnd.gold': 'Золота добыто: {value}',
  'waveEnd.flawless': 'БЕЗУПРЕЧНО! +{value}',
  'waveEnd.continue': '[ клик / Enter — продолжить ]',

  // --- Pause ---
  'pause.title': 'ПАУЗА',
  'pause.resume': 'Esc / P - продолжить',
  'pause.mute': 'M - звук',

  // --- Game over ---
  'gameover.title': 'КОНЕЦ ИГРЫ',
  'gameover.diedOnWave': 'Погиб на волне: {wave}',
  'gameover.caravansRobbed': 'Корованов ограблено: {count}',
  'gameover.score': 'Счёт: {score}',
  'gameover.newRecord': 'НОВЫЙ РЕКОРД!',
  'gameover.record': 'Рекорд: {score} (волна {wave})',
  'gameover.continue': '[ Enter / клик — продолжить ]',
  'gameover.nameTitle': 'ТВОЙ НИК',
  'gameover.namePlaceholder': 'не настоящее имя',
  'gameover.nameOk': 'ГОТОВО',
  'gameover.nameSkip': 'пропустить',
  'gameover.communityCta': '💬 Обсудить в Telegram',
  'menu.privacy': 'Конфиденциальность',
  'menu.telemetryOn': 'Статистика: вкл',
  'menu.telemetryOff': 'Статистика: выкл',
  'menu.leaderboard': 'ЛИДЕРЫ',

  // --- AI overlay ---
  'ai.hints': '1-6: скорость  Esc: пауза  M: звук',

  // --- Реликвии (коллекционная мета-прогрессия) ---
  'relic.reflexes.label': 'Хорошие рефлексы',
  'relic.reflexes.desc': 'Авто-атака, когда враг в зоне досягаемости',
  'relic.coinSense.label': 'Чутьё на наживу',
  'relic.coinSense.desc': 'Монеты за экраном — золотыми стрелками',
  'relic.engineerEye.label': 'Инженерное мышление',
  'relic.engineerEye.desc': 'Показ радиуса атаки стражи + цифры HP',
  'relic.timeSlow.label': 'Замедление времени',
  'relic.timeSlow.desc': 'Время течёт медленнее, когда враги рядом',
  'relic.timeFast.label': 'Ускорение времени',
  'relic.timeFast.desc': 'Время бежит быстрее, когда врагов нет рядом',
  'relic.miserGrip.label': 'Хватка скряги',
  'relic.miserGrip.desc': 'После зачистки волны все монеты летят к тебе',
  'relic.bloodFog.label': 'Кровавый туман',
  'relic.bloodFog.desc': 'При низком HP края экрана наливаются красным',
  'relic.unlocked.title': 'НОВАЯ РЕЛИКВИЯ',
  'relic.unlocked.hint': 'Переключай в главном меню',
  'menu.relics': 'Реликвии:',

  // --- Онбординг новичка (v1.3.0) ---
  'onboarding.mercyHeal': 'Полное исцеление',

  // --- Статусы игрока ---
  'status.stuck': 'ЗАЛИПАНИЕ!',
  'status.autoAttackOn': 'АВТОАТАКА ВКЛ',
  'status.autoAttackOff': 'АВТОАТАКА ВЫКЛ',
  'status.superReady': 'СУПЕР-УДАР ГОТОВ!',
  'status.horseMounted': 'КОНЬ!',
  'status.horseLost': 'КОНЬ УБЕЖАЛ',

  // --- Ништяки с охранников (выпадают из убитой стражи) ---
  'pickup.medkit.label': 'Аптечка',
  'pickup.purse.label': 'Кошель',
  'pickup.rage.label': 'Боевой клич',
  'pickup.frenzy.label': 'Быстрая рука',
  'pickup.guard.label': 'Кураж',
  'pickup.spice.label': 'Мешок специй',
  'pickup.horse.label': 'Конь',
};
